<script lang="ts">
	// shadcn-svelte Dialog.Content (bits-ui), RESTYLED to price-check tokens. Bundles
	// the Portal + Overlay + centered Content + an optional top-right close button.
	// Animations are dropped (no tailwindcss-animate); NO arbitrary `[..]` values.
	import { Dialog as DialogPrimitive } from "bits-ui";
	import type { Snippet } from "svelte";
	import DialogOverlay from "./dialog-overlay.svelte";
	import { cn, type WithoutChildrenOrChild } from "../../../utils.js";
	import { X } from "lucide";
	import Icon from "../../../icon.svelte";

	let {
		ref = $bindable(null),
		class: className,
		portalProps,
		showClose = true,
		children,
		...restProps
	}: WithoutChildrenOrChild<DialogPrimitive.ContentProps> & {
		portalProps?: DialogPrimitive.PortalProps;
		showClose?: boolean;
		children: Snippet;
	} = $props();
</script>

<DialogPrimitive.Portal {...portalProps}>
	<DialogOverlay />
	<DialogPrimitive.Content
		bind:ref
		data-slot="dialog-content"
		class={cn(
			"fixed left-1/2 top-1/2 z-50 grid w-full max-w-md -translate-x-1/2 -translate-y-1/2 gap-4 rounded-lg border border-border bg-surface p-6 text-ink shadow-lg outline-none",
			className
		)}
		{...restProps}
	>
		{@render children()}
		{#if showClose}
			<DialogPrimitive.Close
				class="absolute right-4 top-4 grid size-7 place-items-center rounded-md text-muted outline-none transition-colors hover:bg-surface-muted hover:text-ink focus-visible:ring-2 focus-visible:ring-brand disabled:pointer-events-none"
			>
				<Icon icon={X} size={16} />
				<span class="sr-only">Close</span>
			</DialogPrimitive.Close>
		{/if}
	</DialogPrimitive.Content>
</DialogPrimitive.Portal>
